<template>
  <div class="content2">
    <el-card class="box-card" v-for="(item,index) in menu_list" :key="index">
      <div slot="header" class="clearfix">
        <span>{{ item.name }}</span>
      </div>
      <div v-for="(item2,index2) in item.list" :key="index2">
        <el-link type="primary" @click="navTo(item2.path)">{{ item2.name }}</el-link>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "ReportLegal",
  data(){
    return{
      menu_list:[
        {
          name:"自催报表",
          list:[
            {name:"自催报表明细",path:"/Butler/Legal?ex_btn=自催报表明细"},
            {name:"自催报表统计",path:"/Butler/Legal?ex_btn=自催报表统计"},
            {name:"催费力度统计",path:"/Butler/Legal?card_index=StatisticalTableOfCollectionForce"}
          ]
        },
        {
          name:"诉讼报表",
          list:[
            // {name:"在管项目立案率报表",path:"/Butler/LitigationStatistics"},
            {name:"诉讼凭证报表",path:"/Butler/Litigation"},
            {name:"诉讼状态计划分配表",path:"/Butler/ExpeditingFeesPlan?card_index=ExpeditingFeesPlanContenzioso"},
            {name:"在管项目年度全年诉讼计划表",path:"/Butler/AnnualLitigationPlanForProjectsUnderManagement"},

            // {name:"立案率及回款统计表",path:"/Butler/CaseFilingRateAndPaymentCollectionStatistics"},

            {name:"立案率及回款统计表",path:"/Butler/LawsuitOverview?card_index=RecordFilingRateAndCollectionStatisticsTable"},
            {name:"当月完成率(诉讼)",path:"/Butler/LawsuitOverview?card_index=MonthlyCompletionRate"},
            {name:"月度账龄统计表",path:"/Butler/LawsuitOverview?card_index=MonthlyAgingStatisticsTable"},
            {name:"项目自诉状态统计表",path:"/Butler/Litigation?card_index=RecordFilingStatusStatisticsTable"},
            {name:"月度诉讼统计表（诉讼汇总表）",path:"/Butler/LawsuitOverview?card_index=MonthlyLitigationStatisticsTable"},
            // {name:"项目诉讼&第三方诉讼-月度账龄统计表",path:"/Butler/CaseFilingRateAndPaymentCollectionStatistics"},

          ]
        },
        {
          name:"第三方报表",
          list:[
            {name:"第三方明细表",path:"/Butler/ThirdPartyLegal?ex_btn=第三方明细表"},
            {name:"第三方催缴统计报表",path:"/Butler/ThirdPartyLegal?ex_btn=第三方催缴统计报表"},
            {name:"第三方诉讼状态统计表",path:"/Butler/ThirdPartyLitigation?card_index=RecordFilingStatusStatisticsTable"},
          ]
        },
        {
          name:"其他",
          list:[
            {name:"年度诉讼计划",path:"/Butler/ExpeditingFeesPlan?card_index=ExpeditingFeesPlanContenziosoLayout"},
            {name:"月度诉讼调整",path:"/Butler/ExpeditingFeesPlan?card_index=ExpeditingFeesPlanYearMonth"},
            {name:"抽检明细报表",path:"/Butler/TaskCount?ex_btn=抽检明细报表"},
          ]
        },
      ]
    }
  },
  methods:{
    navTo(path){
      path && ERP.navigateTo(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.content2{
  padding: 20px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .clearfix {
    span{
      font-weight: bold;
      font-size: 14px;
    }
  }

  .box-card {
    width: 45%;
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/ReportLegal.vue